import { Mark, mergeAttributes } from '@tiptap/core';
export const PanelIcon = Mark.create({
  name: 'panelIcon',
  draggable: true,
  priority: 1200,
  addAttributes() {
    var _HTMLAttributes, _HTMLAttributes2, _HTMLAttributes3;
    return {
      href: {
        default: null
      },
      target: {
        default: (_HTMLAttributes = this.options.HTMLAttributes) === null || _HTMLAttributes === void 0 ? void 0 : _HTMLAttributes.target
      },
      rel: {
        default: (_HTMLAttributes2 = this.options.HTMLAttributes) === null || _HTMLAttributes2 === void 0 ? void 0 : _HTMLAttributes2.rel
      },
      class: {
        default: (_HTMLAttributes3 = this.options.HTMLAttributes) === null || _HTMLAttributes3 === void 0 ? void 0 : _HTMLAttributes3.class
      }
    };
  },
  parseHTML() {
    return [{
      tag: 'a.collapsed',
      getAttrs: dom => {
        const href = dom.getAttribute('href');
        return {
          href
        };
      }
    }];
  },
  renderHTML({
    HTMLAttributes
  }) {
    return ['a', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), ['i', {
      class: 'svg'
    }]];
  }
});
//# sourceMappingURL=panel-icon.js.map